module.exports = __webpack_public_path__ + "static/media/scroll.c2b499f8.svg";